import { gql } from '@/__generated__';

const GET_DEVICE_INTEGRATION_GROUPED_ISSUES_COUNT = gql(`#graphql
  query GetDeviceIntegrationGroupedIssuesCount($deviceIntegrationId: Int!, $input: WriteExecutionLogsGroupedIssuesInput) {
    deviceIntegrationRelation(input: { id: $deviceIntegrationId }) {
      id
      writeExecutionLogGroupedIssues(input: $input) {
        id
        pageInfo {
          totalCount
        }
      }
    }
  }
`);

export default GET_DEVICE_INTEGRATION_GROUPED_ISSUES_COUNT;
